export default function Card({ title, value }) {
  return (
    <div className="bg-gray-900 p-6 rounded-xl shadow-lg text-center hover:scale-105 transition-transform">
      <h4 className="text-xl font-semibold mb-2">{title}</h4>
      <p className="text-green-400 text-2xl font-bold">{value}</p>
    </div>
  );
}
